import * as Yup from "yup";

export const dataModel = {
  meetingUuid: "",
  date: "",
  speaker: "",
};

export const validationDataModel = (edit, meetingDates) => {
  if (edit) {
    return Yup.object().shape({
      date: Yup.date()
        .required("La fecha es obligatoria")
        .test(
          "in-meeting-range",
          "La fecha debe estar dentro del rango del meeting",
          function (value) {
            if (!value || !meetingDates) return true;
            const start = new Date(meetingDates.start);
            const end = new Date(meetingDates.end);
            return value >= start && value <= end;
          }
        ),
      speaker: Yup.string().required(""),
    });
  } else {
    return Yup.object().shape({
      // date: Yup.date().required(""),
      date: Yup.date()
        .required("La fecha es obligatoria")
        .test(
          "in-meeting-range",
          "La fecha debe estar dentro del rango del meeting",
          function (value) {
            if (!value || !meetingDates) return true;
            const start = new Date(meetingDates.start);
            const end = new Date(meetingDates.end);
            return value >= start && value <= end;
          }
        ),
      speaker: Yup.string().required(""),
    });
  }
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
